import React from 'react';
import styled from 'styled-components';

const BannerContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: var(--success);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.9rem;
  max-width: 100%;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
  
  @media (max-width: 576px) {
    font-size: 0.8rem;
    padding: 0.5rem;
    width: auto;
    min-width: 200px;
    max-width: 100%;
  }
`;

const BannerIcon = styled.i`
  flex-shrink: 0;
`;

const BannerText = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  
  @media (max-width: 576px) {
    flex-direction: column;
    text-align: center;
    width: 100%;
  }
`;

const TextPart = styled.div`
  white-space: nowrap;
  
  &:first-child::after {
    content: " — ";
    
    @media (max-width: 576px) {
      content: "";
    }
  }
`;

const OneTimePaymentBanner = () => (
  <BannerContainer>
    <BannerIcon className="bi bi-check-circle-fill" />
    <BannerText>
      <TextPart>One-time payment only</TextPart>
      <TextPart>No subscriptions or recurring fees</TextPart>
    </BannerText>
  </BannerContainer>
);

export default OneTimePaymentBanner;
